const TokenKey = 'token';
const refKey = 'ref';
const InsureDataKey = 'InsureData';
const serialNoKey = 'serialNo';

export function getToken() {
  return window.localStorage.getItem(TokenKey);
}

export function setToken(token) {
  return window.localStorage.setItem(TokenKey, token);
}

export function removeToken() {
  return window.localStorage.removeItem(TokenKey);
}

export function getRef() {
  return window.localStorage.getItem(refKey);
}

export function setRef(ref) {
  return window.localStorage.setItem(refKey, ref);
}

export function removeRef() {
  return window.localStorage.removeItem(refKey);
}

export function getInsureData() {
  return JSON.parse(window.localStorage.getItem(InsureDataKey));
}

export function setInsureData(InsureData) {
  return window.localStorage.setItem(InsureDataKey, JSON.stringify(InsureData));
}

export function removeInsureData() {
  return window.localStorage.removeItem(InsureDataKey);
}

export function getSerialNo() {
  return window.localStorage.getItem(serialNoKey);
}

export function setSerialNo(serialNo) {
  return window.localStorage.setItem(serialNoKey, serialNo);
}

export function removeSerialNo() {
  return window.localStorage.removeItem(serialNoKey);
}
